import y from "../../../../public/projects/vtp/projects/y.jpg";
import s from "../../../../public/projects/vtp/logo/s.png";
import evergreen from "../../../../public/projects/vtp/projects/ev.jpg"

// monarque
import overviewImagemonarque from "../../../../public/projects/vtp/monarque/overview/1.webp";
import bannerDesktopImagemonarque from "../../../../public/projects/vtp/monarque/banner/1.webp";
import bannerMobileImagemonarque from "../../../../public/projects/vtp/monarque/banner/2.webp";
import Locationmonarque from "../../../../public/projects/vtp/monarque/location/1.webp";
import Hightlightsmonarque from "../../../../public/projects/vtp/monarque/highlights/1.webp";
import floorplan1monarque from "../../../../public/projects/vtp/monarque/floorplan/1.webp";
import floorplan2monarque from "../../../../public/projects/vtp/monarque/floorplan/2.webp";
import floorplan3monarque from "../../../../public/projects/vtp/monarque/floorplan/3.webp";
import floorplan4monarque from "../../../../public/projects/vtp/monarque/floorplan/4.webp";
import floorplan5monarque from "../../../../public/projects/vtp/monarque/floorplan/5.webp";
import locationiconmonarque from "../../../../public/projects/vtp/monarque/overview/l.png";
import caliconmonarque from "../../../../public/projects/vtp/monarque/overview/c.png";
import newlaunchiconmonarque from "../../../../public/projects/vtp/monarque/overview/n.png";
import gallery1monarque from "../../../../public/projects/vtp/monarque/gallery/1.webp";
import gallery2monarque from "../../../../public/projects/vtp/monarque/gallery/2.webp";
import gallery3monarque from "../../../../public/projects/vtp/monarque/gallery/3.webp";
import gallery4monarque from "../../../../public/projects/vtp/monarque/gallery/4.webp";
import gallery5monarque from "../../../../public/projects/vtp/monarque/gallery/5.webp";

// projecttwo
import overviewImageprojecttwo from "../../../../public/projects/vtp/projecttwo/overview/1.webp";
import bannerDesktopImageprojecttwo from "../../../../public/projects/vtp/projecttwo/banner/1.webp";
import bannerMobileImageprojecttwo from "../../../../public/projects/vtp/projecttwo/banner/2.webp";
import Locationprojecttwo from "../../../../public/projects/vtp/projecttwo/location/1.webp";
import Hightlightsprojecttwo from "../../../../public/projects/vtp/projecttwo/highlights/1.webp";
import floorplan1projecttwo from "../../../../public/projects/vtp/projecttwo/floorplan/1.webp";
import floorplan2projecttwo from "../../../../public/projects/vtp/projecttwo/floorplan/2.webp";
import floorplan3projecttwo from "../../../../public/projects/vtp/projecttwo/floorplan/3.webp";
import floorplan4projecttwo from "../../../../public/projects/vtp/projecttwo/floorplan/4.webp";
import floorplan5projecttwo from "../../../../public/projects/vtp/projecttwo/floorplan/5.webp";
import locationiconprojecttwo from "../../../../public/projects/vtp/projecttwo/overview/l.png";
import caliconprojecttwo from "../../../../public/projects/vtp/projecttwo/overview/c.png";
import newlaunchiconprojecttwo from "../../../../public/projects/vtp/projecttwo/overview/n.png";
import gallery1projecttwo from "../../../../public/projects/vtp/projecttwo/gallery/1.webp";
import gallery2projecttwo from "../../../../public/projects/vtp/projecttwo/gallery/2.webp";
import gallery3projecttwo from "../../../../public/projects/vtp/projecttwo/gallery/3.webp";
import gallery4projecttwo from "../../../../public/projects/vtp/projecttwo/gallery/4.webp";
import gallery5projecttwo from "../../../../public/projects/vtp/projecttwo/gallery/5.webp";

// projectthree
import overviewImageprojectthree from "../../../../public/projects/vtp/projectthree/overview/1.webp";
import bannerDesktopImageprojectthree from "../../../../public/projects/vtp/projectthree/banner/1.webp";
import bannerMobileImageprojectthree from "../../../../public/projects/vtp/projectthree/banner/2.webp";
import Locationprojectthree from "../../../../public/projects/vtp/projectthree/location/1.webp";
import Hightlightsprojectthree from "../../../../public/projects/vtp/projectthree/highlights/1.webp";
import floorplan1projectthree from "../../../../public/projects/vtp/projectthree/floorplan/1.webp";
import floorplan2projectthree from "../../../../public/projects/vtp/projectthree/floorplan/2.webp";
import floorplan3projectthree from "../../../../public/projects/vtp/projectthree/floorplan/3.webp";
import floorplan4projectthree from "../../../../public/projects/vtp/projectthree/floorplan/4.webp";
import floorplan5projectthree from "../../../../public/projects/vtp/projectthree/floorplan/5.webp";
import locationiconprojectthree from "../../../../public/projects/vtp/projectthree/overview/l.png";
import caliconprojectthree from "../../../../public/projects/vtp/projectthree/overview/c.png";
import newlaunchiconprojectthree from "../../../../public/projects/vtp/projectthree/overview/n.png";
import gallery1projectthree from "../../../../public/projects/vtp/projectthree/gallery/1.webp";
import gallery2projectthree from "../../../../public/projects/vtp/projectthree/gallery/2.webp";
import gallery3projectthree from "../../../../public/projects/vtp/projectthree/gallery/3.webp";
import gallery4projectthree from "../../../../public/projects/vtp/projectthree/gallery/4.webp";
import gallery5projectthree from "../../../../public/projects/vtp/projectthree/gallery/5.webp";

// projectfour
import overviewImageprojectfour from "../../../../public/projects/vtp/projectfour/overview/1.webp";
import bannerDesktopImageprojectfour from "../../../../public/projects/vtp/projectfour/banner/1.webp";
import bannerMobileImageprojectfour from "../../../../public/projects/vtp/projectfour/banner/2.webp";
import Locationprojectfour from "../../../../public/projects/vtp/projectfour/location/1.webp";
import Hightlightsprojectfour from "../../../../public/projects/vtp/projectfour/highlights/1.webp";
import floorplan1projectfour from "../../../../public/projects/vtp/projectfour/floorplan/1.webp";
import floorplan2projectfour from "../../../../public/projects/vtp/projectfour/floorplan/2.webp";
import floorplan3projectfour from "../../../../public/projects/vtp/projectfour/floorplan/3.webp";
import floorplan4projectfour from "../../../../public/projects/vtp/projectfour/floorplan/4.webp";
import floorplan5projectfour from "../../../../public/projects/vtp/projectfour/floorplan/5.webp";
import locationiconprojectfour from "../../../../public/projects/vtp/projectfour/overview/l.png";
import caliconprojectfour from "../../../../public/projects/vtp/projectfour/overview/c.png";
import newlaunchiconprojectfour from "../../../../public/projects/vtp/projectfour/overview/n.png";
import gallery1projectfour from "../../../../public/projects/vtp/projectfour/gallery/1.webp";
import gallery2projectfour from "../../../../public/projects/vtp/projectfour/gallery/2.webp";
import gallery3projectfour from "../../../../public/projects/vtp/projectfour/gallery/3.webp";
import gallery4projectfour from "../../../../public/projects/vtp/projectfour/gallery/4.webp";
import gallery5projectfour from "../../../../public/projects/vtp/projectfour/gallery/5.webp";

// projectfive
import overviewImageprojectfive from "../../../../public/projects/vtp/projectfive/overview/1.webp";
import bannerDesktopImageprojectfive from "../../../../public/projects/vtp/projectfive/banner/1.webp";
import bannerMobileImageprojectfive from "../../../../public/projects/vtp/projectfive/banner/2.webp";
import Locationprojectfive from "../../../../public/projects/vtp/projectfive/location/1.webp";
import Hightlightsprojectfive from "../../../../public/projects/vtp/projectfive/highlights/1.webp";
import floorplan1projectfive from "../../../../public/projects/vtp/projectfive/floorplan/1.webp";
import floorplan2projectfive from "../../../../public/projects/vtp/projectfive/floorplan/2.webp";
import floorplan3projectfive from "../../../../public/projects/vtp/projectfive/floorplan/3.webp";
import floorplan4projectfive from "../../../../public/projects/vtp/projectfive/floorplan/4.webp";
import floorplan5projectfive from "../../../../public/projects/vtp/projectfive/floorplan/5.webp";
import locationiconprojectfive from "../../../../public/projects/vtp/projectfive/overview/l.png";
import caliconprojectfive from "../../../../public/projects/vtp/projectfive/overview/c.png";
import newlaunchiconprojectfive from "../../../../public/projects/vtp/projectfive/overview/n.png";
import gallery1projectfive from "../../../../public/projects/vtp/projectfive/gallery/1.webp";
import gallery2projectfive from "../../../../public/projects/vtp/projectfive/gallery/2.webp";
import gallery3projectfive from "../../../../public/projects/vtp/projectfive/gallery/3.webp";
import gallery4projectfive from "../../../../public/projects/vtp/projectfive/gallery/4.webp";
import gallery5projectfive from "../../../../public/projects/vtp/projectfive/gallery/5.webp";

// projectsix
import overviewImageprojectsix from "../../../../public/projects/vtp/projectsix/overview/1.webp";
import bannerDesktopImageprojectsix from "../../../../public/projects/vtp/projectsix/banner/1.webp";
import bannerMobileImageprojectsix from "../../../../public/projects/vtp/projectsix/banner/2.webp";
import Locationprojectsix from "../../../../public/projects/vtp/projectsix/location/1.webp";
import Hightlightsprojectsix from "../../../../public/projects/vtp/projectsix/highlights/1.webp";
import floorplan1projectsix from "../../../../public/projects/vtp/projectsix/floorplan/1.webp";
import floorplan2projectsix from "../../../../public/projects/vtp/projectsix/floorplan/2.webp";
import floorplan3projectsix from "../../../../public/projects/vtp/projectsix/floorplan/3.webp";
import floorplan4projectsix from "../../../../public/projects/vtp/projectsix/floorplan/4.webp";
import floorplan5projectsix from "../../../../public/projects/vtp/projectsix/floorplan/5.webp";
import locationiconprojectsix from "../../../../public/projects/vtp/projectsix/overview/l.png";
import caliconprojectsix from "../../../../public/projects/vtp/projectsix/overview/c.png";
import newlaunchiconprojectsix from "../../../../public/projects/vtp/projectsix/overview/n.png";
import gallery1projectsix from "../../../../public/projects/vtp/projectsix/gallery/1.webp";
import gallery2projectsix from "../../../../public/projects/vtp/projectsix/gallery/2.webp";
import gallery3projectsix from "../../../../public/projects/vtp/projectsix/gallery/3.webp";
import gallery4projectsix from "../../../../public/projects/vtp/projectsix/gallery/4.webp";
import gallery5projectsix from "../../../../public/projects/vtp/projectsix/gallery/5.webp";

// projectseven
import overviewImageprojectseven from "../../../../public/projects/vtp/projectseven/overview/1.webp";
import bannerDesktopImageprojectseven from "../../../../public/projects/vtp/projectseven/banner/1.webp";
import bannerMobileImageprojectseven from "../../../../public/projects/vtp/projectseven/banner/2.webp";
import Locationprojectseven from "../../../../public/projects/vtp/projectseven/location/1.webp";
import Hightlightsprojectseven from "../../../../public/projects/vtp/projectseven/highlights/1.webp";
import floorplan1projectseven from "../../../../public/projects/vtp/projectseven/floorplan/1.webp";
import floorplan2projectseven from "../../../../public/projects/vtp/projectseven/floorplan/2.webp";
import floorplan3projectseven from "../../../../public/projects/vtp/projectseven/floorplan/3.webp";
import floorplan4projectseven from "../../../../public/projects/vtp/projectseven/floorplan/4.webp";
import floorplan5projectseven from "../../../../public/projects/vtp/projectseven/floorplan/5.webp";
import locationiconprojectseven from "../../../../public/projects/vtp/projectseven/overview/l.png";
import caliconprojectseven from "../../../../public/projects/vtp/projectseven/overview/c.png";
import newlaunchiconprojectseven from "../../../../public/projects/vtp/projectseven/overview/n.png";
import gallery1projectseven from "../../../../public/projects/vtp/projectseven/gallery/1.webp";
import gallery2projectseven from "../../../../public/projects/vtp/projectseven/gallery/2.webp";
import gallery3projectseven from "../../../../public/projects/vtp/projectseven/gallery/3.webp";
import gallery4projectseven from "../../../../public/projects/vtp/projectseven/gallery/4.webp";
import gallery5projectseven from "../../../../public/projects/vtp/projectseven/gallery/5.webp";

// projecteight
import overviewImageprojecteight from "../../../../public/projects/vtp/projecteight/overview/1.webp";
import bannerDesktopImageprojecteight from "../../../../public/projects/vtp/projecteight/banner/1.webp";
import bannerMobileImageprojecteight from "../../../../public/projects/vtp/projecteight/banner/2.webp";
import Locationprojecteight from "../../../../public/projects/vtp/projecteight/location/1.webp";
import Hightlightsprojecteight from "../../../../public/projects/vtp/projecteight/highlights/1.webp";
import floorplan1projecteight from "../../../../public/projects/vtp/projecteight/floorplan/1.webp";
import floorplan2projecteight from "../../../../public/projects/vtp/projecteight/floorplan/2.webp";
import floorplan3projecteight from "../../../../public/projects/vtp/projecteight/floorplan/3.webp";
import floorplan4projecteight from "../../../../public/projects/vtp/projecteight/floorplan/4.webp";
import floorplan5projecteight from "../../../../public/projects/vtp/projecteight/floorplan/5.webp";
import locationiconprojecteight from "../../../../public/projects/vtp/projecteight/overview/l.png";
import caliconprojecteight from "../../../../public/projects/vtp/projecteight/overview/c.png";
import newlaunchiconprojecteight from "../../../../public/projects/vtp/projecteight/overview/n.png";
import gallery1projecteight from "../../../../public/projects/vtp/projecteight/gallery/1.webp";
import gallery2projecteight from "../../../../public/projects/vtp/projecteight/gallery/2.webp";
import gallery3projecteight from "../../../../public/projects/vtp/projecteight/gallery/3.webp";
import gallery4projecteight from "../../../../public/projects/vtp/projecteight/gallery/4.webp";
import gallery5projecteight from "../../../../public/projects/vtp/projecteight/gallery/5.webp";

// projectnine
import overviewImageprojectnine from "../../../../public/projects/vtp/projectnine/overview/1.webp";
import bannerDesktopImageprojectnine from "../../../../public/projects/vtp/projectnine/banner/1.webp";
import bannerMobileImageprojectnine from "../../../../public/projects/vtp/projectnine/banner/2.webp";
import Locationprojectnine from "../../../../public/projects/vtp/projectnine/location/1.webp";
import Hightlightsprojectnine from "../../../../public/projects/vtp/projectnine/highlights/1.webp";
import floorplan1projectnine from "../../../../public/projects/vtp/projectnine/floorplan/1.webp";
import floorplan2projectnine from "../../../../public/projects/vtp/projectnine/floorplan/2.webp";
import floorplan3projectnine from "../../../../public/projects/vtp/projectnine/floorplan/3.webp";
import floorplan4projectnine from "../../../../public/projects/vtp/projectnine/floorplan/4.webp";
import floorplan5projectnine from "../../../../public/projects/vtp/projectnine/floorplan/5.webp";
import locationiconprojectnine from "../../../../public/projects/vtp/projectnine/overview/l.png";
import caliconprojectnine from "../../../../public/projects/vtp/projectnine/overview/c.png";
import newlaunchiconprojectnine from "../../../../public/projects/vtp/projectnine/overview/n.png";
import gallery1projectnine from "../../../../public/projects/vtp/projectnine/gallery/1.webp";
import gallery2projectnine from "../../../../public/projects/vtp/projectnine/gallery/2.webp";
import gallery3projectnine from "../../../../public/projects/vtp/projectnine/gallery/3.webp";
import gallery4projectnine from "../../../../public/projects/vtp/projectnine/gallery/4.webp";
import gallery5projectnine from "../../../../public/projects/vtp/projectnine/gallery/5.webp";

// projectten
import overviewImageprojectten from "../../../../public/projects/vtp/projectten/overview/1.webp";
import bannerDesktopImageprojectten from "../../../../public/projects/vtp/projectten/banner/1.webp";
import bannerMobileImageprojectten from "../../../../public/projects/vtp/projectten/banner/2.webp";
import Locationprojectten from "../../../../public/projects/vtp/projectten/location/1.webp";
import Hightlightsprojectten from "../../../../public/projects/vtp/projectten/highlights/1.webp";
import floorplan1projectten from "../../../../public/projects/vtp/projectten/floorplan/1.webp";
import floorplan2projectten from "../../../../public/projects/vtp/projectten/floorplan/2.webp";
import floorplan3projectten from "../../../../public/projects/vtp/projectten/floorplan/3.webp";
import floorplan4projectten from "../../../../public/projects/vtp/projectten/floorplan/4.webp";
import floorplan5projectten from "../../../../public/projects/vtp/projectten/floorplan/5.webp";
import locationiconprojectten from "../../../../public/projects/vtp/projectten/overview/l.png";
import caliconprojectten from "../../../../public/projects/vtp/projectten/overview/c.png";
import newlaunchiconprojectten from "../../../../public/projects/vtp/projectten/overview/n.png";
import gallery1projectten from "../../../../public/projects/vtp/projectten/gallery/1.webp";
import gallery2projectten from "../../../../public/projects/vtp/projectten/gallery/2.webp";
import gallery3projectten from "../../../../public/projects/vtp/projectten/gallery/3.webp";
import gallery4projectten from "../../../../public/projects/vtp/projectten/gallery/4.webp";
import gallery5projectten from "../../../../public/projects/vtp/projectten/gallery/5.webp";



export const developervtp = {
  properties: [
    {
      name: "vtp The Trillion",
      image: bannerMobileImagemonarque,
      price: " 6.14 Crore Onwards",
      state: " Gurugram",
      developer: "vtp",
      location: "Sector 48, Gurugram",
      projectlocation: "Gurugram",
      bed: "3,4 BHK Apartments",
      size: "3000-3600 sq.ft.",
      url: `/vtp-trillion`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "vtp The Trillion",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "2006",
  },
  about: `vtp, a 100% FDI funded real-estate developer, backed by vtp Holdings Pte. Ltd., Singapore, the real estate investing division of the AT Holdings group of companies. AT Capital, headquartered in Singapore, was established with the aim of capitalizing on global opportunities within both established and emerging sectors.`,
};


export const projectsvtp = {

  monarque: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagemonarque,
      bannerMobileImage: bannerMobileImagemonarque,
      textOverlay: "",
      data: {
        title: "VTP Monarque",
        subtitle: "Hinjewadi, Pune",
        starting_price: "₹ 94 L - 2.75 Cr Onwards",
        payment_plan: "Under Construction",
        rerano: "",
        status: "Under Construction"
      }
    },

    overview: {
      heading: "VTP Monarque",
      description: [
        "VTP Monarque Hinjewadi Pune is a top choice for people looking for luxury homes in a busy area of Pune. This project by VTP Realty is located in Hinjewadi Phase 1, making it ideal for workers in IT and families who want convenience. It offers 2 BHK flats that are stylish and practical.",
        "The development covers over 10 acres and has seven tall towers, providing great views and lots of natural light. The apartments are designed to use space efficiently, with smart layouts for comfort. Each home has modern smart features, secure locks, and high-quality finishes, showing a focus on luxury.",
        "Residents have access to over 3 acres of open space and excellent amenities. There are two large clubhouses, various themed gardens, four swimming pools, and a long jogging and cycling track to encourage a healthy lifestyle. The project also includes a 600-meter shopping street, car-free areas, and stylish entrances, adding to the convenience. Security is strong, with advanced surveillance and guards to keep residents safe.",
        "VTP Monarque is well-connected to the Mumbai-Bangalore Highway, Infosys Circle, good schools, and healthcare centers, making daily life easy. Its closeness to major IT parks is great for professionals looking for homes that help balance work and life.",
        "For those looking for 2 BHK flats in Pune Hinjewadi, VTP Monarque offers a mix of luxury, practicality, and modern living. Its design, open views, and full range of amenities make it a great choice for those wanting a comfortable and lively lifestyle in Pune's growing real estate market.",
      ],
      keywordLinks: {
      },
      image: overviewImagemonarque,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconmonarque,
          title: "₹ 94 L  Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconmonarque,
          title: "Under Construction",
          subtitle: "Status"
        },
        {
          iconClass: newlaunchiconmonarque,
          title: "10+ Acres",
          subtitle: "Project Area"
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "806 - 860 sq.ft.",
          price: "₹ 94 L - 1.01 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "1094 - 1486 sq.ft.",
          price: "₹ 1.36 - 1.95 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "1616 sq.ft.",
          price: "₹ 2.07 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "5 BHK",
          area: "2093 sq.ft.",
          price: "₹ 2.75 Cr",
          eoiAmount: "On Request",
        }
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "806 - 860 sq.ft.",
        price: "₹ 94 L - 1.01 Cr",
        image: floorplan1monarque,
      },
      {
        type: "3 BHK",
        area: "1094 - 1486 sq.ft.",
        price: "₹ 1.36 - 1.95 Cr",
        image: floorplan2monarque,
      }, {
        type: "4 BHK",
        area: "1616 sq.ft.",
        price: "₹ 2.07 Cr",
        image: floorplan3monarque,
      },
      {
        type: "5 BHK",
        area: "2093 sq.ft.",
        price: "₹ 2.75 Cr",
        image: floorplan4monarque,
      }
    ],

    highlights: {
      images: Hightlightsmonarque,
      tagline: "Highlights",
      features: [
        "Separate towers with no shared walls.   ",
        "The longest cycling and jogging track in Pune, 1.2 km long, is in a area without vehicles.  ",
        "Each tower and home has access to this area.  ",
        "There is a 600-meter long shopping area.   ",
        "A large clubhouse with two levels. ",
      ],
    },

    location: {
      image: Locationmonarque,
      data: [
        {
          airport: {
            distance_time: "26.1 Km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "2.8 Km",
            name: "BLISS International School"
          },
          railwayormetro: {
            distance_time: "11.8 Km",
            name: "Chinchwad Junction"
          },
          hospital: {
            distance_time: "3.5 Km",
            name: "Nexus Care Hospital"
          },
          mall: {
            distance_time: "4 Km",
            name: "Xion Mall"
          }
        }
      ]
    },
    

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1monarque },
        { image: gallery2monarque },
        { image: gallery3monarque },
        { image: gallery4monarque },
        { image: gallery5monarque },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in VTP Monarque, kindly share more details.",
    },

    faq: [
      {
        question: "Where is VTP Monarque located?",
        answer: "VTP Monarque is located in Hinjewadi Phase 1, Pune."
      },
      {
        question: "What types of apartments are available at VTP Monarque?",
        answer: "The project offers 1, 2, 2.5, and 3 BHK apartments."
      },
      {
        question: "What is the total area of the VTP Monarque project?",
        answer: "VTP Monarque is spread over more than 10 acres."
      },
      {
        question: "How many towers and floors does the project have?",
        answer: "The project features seven majestic towers, each rising up to 30 storeys."
      },
      {
        question: "What security features are available at VTP Monarque?",
        answer: "The project is equipped with surveillance cameras, security guards at all gates, and secure parking."
      },
      {
        question: "Are there any special features for families and children?",
        answer: "Yes, VTP Monarque offers modern equipped play areas with soft ground surfaces for children."
      },
      {
        question: "What flooring and interior specifications are offered?",
        answer: "The apartments feature large-sized marble finish glazed vitrified tiles, anti-skid tiles in bathrooms."
      },
      {
        question: "Is the project suitable for IT professionals?",
        answer: "Yes, VTP Monarque is ideal for IT professionals due to its proximity to major IT parks."
      },
      {
        question: "What makes VTP Monarque stand out in Hinjewadi?",
        answer: "The project stands out for its luxurious amenities and smart home automation."
      },
      {
        question: "Who is the developer behind VTP Monarque?",
        answer: "VTP Monarque is developed by VTP Realty."
      }
    ],
    


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecttwo: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecttwo,
      bannerMobileImage: bannerMobileImageprojecttwo,
      textOverlay: "",
      data: {
        title: "vtp The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vtp The Trillion",
      description: [
        "vtp The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vtp Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vtp Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vtp Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vtp The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vtp": "/developers/vtp",
      },
      image: overviewImageprojecttwo,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecttwo,
          title: "₹ 94 L - 2.75 Cr Onwards",
          subtitle: "Starting Price",
          description: "2 BHK: ₹ 94 L - 1.01 Cr | 3 BHK: ₹ 1.36 - 1.95 Cr | 4 BHK: ₹ 2.07 Cr | 5 BHK: ₹ 2.75 Cr"
        },
        {
          iconClass: caliconprojecttwo,
          title: "Under Construction",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconprojecttwo,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecttwo,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecttwo,
      }
    ],

    highlights: {
      images: Hightlightsprojecttwo,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecttwo,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecttwo },
        { image: gallery2projecttwo },
        { image: gallery3projecttwo },
        { image: gallery4projecttwo },
        { image: gallery5projecttwo },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vtp The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vtp The Trillion located?",
        answer: `vtp The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vtp The Trillion?",
        answer: `vtp The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vtp The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vtp The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vtp The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vtp The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vtp The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vtp The Trillion?",
        answer: `vtp The Trillion is developed by vtp Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vtp The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vtp The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vtp The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectthree: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectthree,
      bannerMobileImage: bannerMobileImageprojectthree,
      textOverlay: "",
      data: {
        title: "vtp The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vtp The Trillion",
      description: [
        "vtp The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vtp Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vtp Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vtp Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vtp The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vtp": "/developers/vtp",
      },
      image: overviewImageprojectthree,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectthree,
          title: "₹ 94 L - 2.75 Cr Onwards",
          subtitle: "Starting Price",
          description: "2 BHK: ₹ 94 L - 1.01 Cr | 3 BHK: ₹ 1.36 - 1.95 Cr | 4 BHK: ₹ 2.07 Cr | 5 BHK: ₹ 2.75 Cr"
        },
        {
          iconClass: caliconprojectthree,
          title: "Under Construction",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconprojectthree,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectthree,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectthree,
      }
    ],

    highlights: {
      images: Hightlightsprojectthree,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectthree,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectthree },
        { image: gallery2projectthree },
        { image: gallery3projectthree },
        { image: gallery4projectthree },
        { image: gallery5projectthree },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vtp The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vtp The Trillion located?",
        answer: `vtp The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vtp The Trillion?",
        answer: `vtp The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vtp The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vtp The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vtp The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vtp The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vtp The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vtp The Trillion?",
        answer: `vtp The Trillion is developed by vtp Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vtp The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vtp The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vtp The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfour: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfour,
      bannerMobileImage: bannerMobileImageprojectfour,
      textOverlay: "",
      data: {
        title: "vtp The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vtp The Trillion",
      description: [
        "vtp The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vtp Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vtp Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vtp Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vtp The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vtp": "/developers/vtp",
      },
      image: overviewImageprojectfour,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfour,
          title: "₹ 94 L - 2.75 Cr Onwards",
          subtitle: "Starting Price",
          description: "2 BHK: ₹ 94 L - 1.01 Cr | 3 BHK: ₹ 1.36 - 1.95 Cr | 4 BHK: ₹ 2.07 Cr | 5 BHK: ₹ 2.75 Cr"
        },
        {
          iconClass: caliconprojectfour,
          title: "Under Construction",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconprojectfour,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfour,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfour,
      }
    ],

    highlights: {
      images: Hightlightsprojectfour,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfour,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfour },
        { image: gallery2projectfour },
        { image: gallery3projectfour },
        { image: gallery4projectfour },
        { image: gallery5projectfour },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vtp The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vtp The Trillion located?",
        answer: `vtp The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vtp The Trillion?",
        answer: `vtp The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vtp The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vtp The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vtp The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vtp The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vtp The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vtp The Trillion?",
        answer: `vtp The Trillion is developed by vtp Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vtp The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vtp The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vtp The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfive: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfive,
      bannerMobileImage: bannerMobileImageprojectfive,
      textOverlay: "",
      data: {
        title: "vtp The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vtp The Trillion",
      description: [
        "vtp The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vtp Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vtp Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vtp Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vtp The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vtp": "/developers/vtp",
      },
      image: overviewImageprojectfive,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfive,
          title: "₹ 94 L - 2.75 Cr Onwards",
          subtitle: "Starting Price",
          description: "2 BHK: ₹ 94 L - 1.01 Cr | 3 BHK: ₹ 1.36 - 1.95 Cr | 4 BHK: ₹ 2.07 Cr | 5 BHK: ₹ 2.75 Cr"
        },
        {
          iconClass: caliconprojectfive,
          title: "Under Construction",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconprojectfive,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfive,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfive,
      }
    ],

    highlights: {
      images: Hightlightsprojectfive,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfive,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfive },
        { image: gallery2projectfive },
        { image: gallery3projectfive },
        { image: gallery4projectfive },
        { image: gallery5projectfive },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vtp The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vtp The Trillion located?",
        answer: `vtp The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vtp The Trillion?",
        answer: `vtp The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vtp The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vtp The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vtp The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vtp The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vtp The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vtp The Trillion?",
        answer: `vtp The Trillion is developed by vtp Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vtp The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vtp The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vtp The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectsix: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectsix,
      bannerMobileImage: bannerMobileImageprojectsix,
      textOverlay: "",
      data: {
        title: "vtp The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vtp The Trillion",
      description: [
        "vtp The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vtp Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vtp Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vtp Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vtp The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vtp": "/developers/vtp",
      },
      image: overviewImageprojectsix,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectsix,
          title: "₹ 94 L - 2.75 Cr Onwards",
          subtitle: "Starting Price",
          description: "2 BHK: ₹ 94 L - 1.01 Cr | 3 BHK: ₹ 1.36 - 1.95 Cr | 4 BHK: ₹ 2.07 Cr | 5 BHK: ₹ 2.75 Cr"
        },
        {
          iconClass: caliconprojectsix,
          title: "Under Construction",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconprojectsix,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectsix,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectsix,
      }
    ],

    highlights: {
      images: Hightlightsprojectsix,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectsix,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectsix },
        { image: gallery2projectsix },
        { image: gallery3projectsix },
        { image: gallery4projectsix },
        { image: gallery5projectsix },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vtp The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vtp The Trillion located?",
        answer: `vtp The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vtp The Trillion?",
        answer: `vtp The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vtp The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vtp The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vtp The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vtp The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vtp The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vtp The Trillion?",
        answer: `vtp The Trillion is developed by vtp Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vtp The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vtp The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vtp The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectseven: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectseven,
      bannerMobileImage: bannerMobileImageprojectseven,
      textOverlay: "",
      data: {
        title: "vtp The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vtp The Trillion",
      description: [
        "vtp The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vtp Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vtp Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vtp Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vtp The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vtp": "/developers/vtp",
      },
      image: overviewImageprojectseven,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectseven,
          title: "₹ 94 L - 2.75 Cr Onwards",
          subtitle: "Starting Price",
          description: "2 BHK: ₹ 94 L - 1.01 Cr | 3 BHK: ₹ 1.36 - 1.95 Cr | 4 BHK: ₹ 2.07 Cr | 5 BHK: ₹ 2.75 Cr"
        },
        {
          iconClass: caliconprojectseven,
          title: "Under Construction",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconprojectseven,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectseven,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectseven,
      }
    ],

    highlights: {
      images: Hightlightsprojectseven,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectseven,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectseven },
        { image: gallery2projectseven },
        { image: gallery3projectseven },
        { image: gallery4projectseven },
        { image: gallery5projectseven },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vtp The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vtp The Trillion located?",
        answer: `vtp The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vtp The Trillion?",
        answer: `vtp The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vtp The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vtp The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vtp The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vtp The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vtp The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vtp The Trillion?",
        answer: `vtp The Trillion is developed by vtp Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vtp The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vtp The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vtp The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecteight: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecteight,
      bannerMobileImage: bannerMobileImageprojecteight,
      textOverlay: "",
      data: {
        title: "vtp The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vtp The Trillion",
      description: [
        "vtp The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vtp Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vtp Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vtp Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vtp The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vtp": "/developers/vtp",
      },
      image: overviewImageprojecteight,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecteight,
          title: "₹ 94 L - 2.75 Cr Onwards",
          subtitle: "Starting Price",
          description: "2 BHK: ₹ 94 L - 1.01 Cr | 3 BHK: ₹ 1.36 - 1.95 Cr | 4 BHK: ₹ 2.07 Cr | 5 BHK: ₹ 2.75 Cr"
        },
        {
          iconClass: caliconprojecteight,
          title: "Under Construction",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconprojecteight,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecteight,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecteight,
      }
    ],

    highlights: {
      images: Hightlightsprojecteight,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecteight,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecteight },
        { image: gallery2projecteight },
        { image: gallery3projecteight },
        { image: gallery4projecteight },
        { image: gallery5projecteight },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vtp The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vtp The Trillion located?",
        answer: `vtp The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vtp The Trillion?",
        answer: `vtp The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vtp The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vtp The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vtp The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vtp The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vtp The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vtp The Trillion?",
        answer: `vtp The Trillion is developed by vtp Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vtp The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vtp The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vtp The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectnine: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectnine,
      bannerMobileImage: bannerMobileImageprojectnine,
      textOverlay: "",
      data: {
        title: "vtp The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vtp The Trillion",
      description: [
        "vtp The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vtp Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vtp Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vtp Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vtp The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vtp": "/developers/vtp",
      },
      image: overviewImageprojectnine,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectnine,
          title: "₹ 94 L - 2.75 Cr Onwards",
          subtitle: "Starting Price",
          description: "2 BHK: ₹ 94 L - 1.01 Cr | 3 BHK: ₹ 1.36 - 1.95 Cr | 4 BHK: ₹ 2.07 Cr | 5 BHK: ₹ 2.75 Cr"
        },
        {
          iconClass: caliconprojectnine,
          title: "Under Construction",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconprojectnine,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectnine,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectnine,
      }
    ],

    highlights: {
      images: Hightlightsprojectnine,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectnine,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectnine },
        { image: gallery2projectnine },
        { image: gallery3projectnine },
        { image: gallery4projectnine },
        { image: gallery5projectnine },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vtp The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vtp The Trillion located?",
        answer: `vtp The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vtp The Trillion?",
        answer: `vtp The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vtp The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vtp The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vtp The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vtp The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vtp The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vtp The Trillion?",
        answer: `vtp The Trillion is developed by vtp Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vtp The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vtp The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vtp The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectten: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectten,
      bannerMobileImage: bannerMobileImageprojectten,
      textOverlay: "",
      data: {
        title: "vtp The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vtp The Trillion",
      description: [
        "vtp The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vtp Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vtp Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vtp Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vtp The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vtp": "/developers/vtp",
      },
      image: overviewImageprojectten,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectten,
          title: "₹ 94 L - 2.75 Cr Onwards",
          subtitle: "Starting Price",
          description: "2 BHK: ₹ 94 L - 1.01 Cr | 3 BHK: ₹ 1.36 - 1.95 Cr | 4 BHK: ₹ 2.07 Cr | 5 BHK: ₹ 2.75 Cr"
        },
        {
          iconClass: caliconprojectten,
          title: "Under Construction",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconprojectten,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectten,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectten,
      }
    ],

    highlights: {
      images: Hightlightsprojectten,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectten,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectten },
        { image: gallery2projectten },
        { image: gallery3projectten },
        { image: gallery4projectten },
        { image: gallery5projectten },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vtp The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vtp The Trillion located?",
        answer: `vtp The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vtp The Trillion?",
        answer: `vtp The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vtp The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vtp The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vtp The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vtp The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vtp The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vtp The Trillion?",
        answer: `vtp The Trillion is developed by vtp Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vtp The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vtp The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vtp The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
